<template>
    <div class="profile-about-blocks d-flex">

        <div class="profile-about-blocks__item">

            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">{{stats.supported_active_projects_count || 0}}</span>
                {{$store.getters.t('organizations_about_projects_in_progress')}} <br> {{$store.getters.t('organizations_about_in_realization')}}
            </div>

        </div>

        <div class="profile-about-blocks__item">

            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">{{stats.members_personal_pets_count || 0}}</span>
                {{$store.getters.t('organizations_about_pets')}} <br> {{$store.getters.t('organizations_about_employees')}}
            </div>

        </div>

        <div class="profile-about-blocks__item">
            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">{{stats.supported_active_pets_count || 0}}</span>
                {{$store.getters.t('organizations_about_pets_in_care_prefix')}} <br>{{$store.getters.t('organizations_about_pets_in_care_suffix')}}
            </div>
        </div>

        <div class="profile-about-blocks__item">
            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">{{ stats.supported_projects_count || 0 }}</span>
                {{$store.getters.t('organizations_about_projects')}} <br>{{$store.getters.t('organizations_about_supported')}}
            </div>
        </div>

        <div class="profile-about-blocks__item">
            <div class="profile-about-blocks__item-content d-flex">
                <span class="profile-about-blocks__item-content-counter">
                    {{stats['donated_total']}} EUR
                </span>
                {{$store.getters.t('organizations_about_donated')}}
            </div>

        </div>

    </div>
</template>

<script>


export default {
    props: ['stats'],
    name: "OrganizationAbout",



}
</script>

<style scoped>

</style>
